import PropTypes from 'prop-types';

class Client {
  static get TYPE() {
    return 'client';
  }

  static fromAPIResponse(res) {
    if (res.type !== Client.TYPE) {
      return new Client();
    }
    return Object.assign(new Client(), res.attributes, {
      id: res.id,
    });
  }

  constructor() {
    this.id = 0;
    this.householdId = 0;
    this.isPrimary = false;
    this.birthDate = 0;
    this.firstName = '';
    this.lastName = '';
    this.pronunciation = '';
    this.primaryPhoneNumber = '';
    this.miniQuestionnaireCompleted = false;
    this.miniQuestionnaireCurrentSlide = 0;
  }
}

export default Client;

export const propTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  householdId: PropTypes.number.isRequired,
  birthDate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  primaryPhoneNumber: PropTypes.string,
  pronunciation: PropTypes.string,
  miniQuestionnaireCompleted: PropTypes.bool,
});
